<template>
  <div class="main-container">
    <!-- 头部栏 -->
    <HomeHeader tabIndex="2" />
    <!-- 内容 -->
    <div class="container">
      <div class="title">公司简介</div>
      <p>集友科技创新（深圳）有限公司成立于2020年9月21日，为厦门国际银行控股的集团成员之一。</p>
      <p>集友科创遵照集团统筹、高起点、独立性的战略部署，全力建设集团金融科技创新的窗口平台。厦门国际银行集团秉持科技引领业务发展理念，聚焦“数据+AI+云计算”，目前已打造“智腾”小微金融服务、“智享”数字消费金融、“智信”综合支付三大产品服务体系，拥有兴安贷+、税享贷等特色数字小微和零售贷款产品。同时建成公司金融数字化平台“融升”创新授信、“慧升”支付结算、“盈升”渠道服务三大产品体系，创新推出产e融、链e融、信e融等品牌产品和服务。</p>
      <p>同时，集友科创积极响应深圳建设“全球金融科技中心”的号召，扎根深圳，依托厦门国际银行（及成员集友银行、澳门国际银行）的科技金融的优势资源，助力粤港澳大湾区产业数字化转型、创新数字化产业金融服务、赋能产业转型升级，打造成厦门国际银行的“技术高地”、“人才高地”、“资本高地”，努力建设成国内金融科技最领先的银行科技子公司，为深圳社会主义先行示范区建设发挥积极作用。</p>
      <img class="bottom-img" :src="contentBg" />
    </div>
    <!-- 底部栏 -->
    <HomeFooter />
  </div>
</template>

<script>
import HomeHeader from '@/components/HomeHeader.vue'
import HomeFooter from '@/components/HomeFooter.vue'
export default {
  name: 'introduction',
  components: { HomeHeader, HomeFooter },
  data () {
    return {
      contentBg: require('@/assets/images/body_bg.png')
    }
  }
}
</script>

<style scoped lang="less">
  .main-container {
    .container {
      position: relative;
      margin: auto;
      width: 800px;
      min-height: calc(100vh - 200px);
      padding-bottom: 300px;
      box-sizing: border-box;
    }
    .title {
      padding: 30px 0 10px;
      font-size: 32px;
      text-align: center;
    }
    p {
      font-size: 18px;
      text-indent: 2em;
      text-align: justify;
    }
    .team-img {
      margin-left: 25%;
      width: 50%;
    }
    .bottom-img {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
  }
</style>